import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ImageBackground,
    TextProps
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';


type ProjectsScreenNavigationProp = StackNavigationProp< any, 'Projects'>;
interface IProps {

}
interface IState {

}

export default class AppText extends React.Component<TextProps> {

    state:IState={

    }
    componentDidMount() {

    }

    render() {
        return(
            <Text numberOfLines={this.props.numberOfLines} style={[{fontFamily:'Heebo'},this.props.style,{paddingTop:0}]}>{this.props.children}</Text>
        );
    }
}

